import RestaurantReducer from './reducers/RestaurantReducer';
import SocieteReducer from './reducers/SocieteReducer';
import ClientReducer from './reducers/ClientReducer';
import DataRestaurantReducer from './reducers/DataRestaurantReducer';
import OffreReducer from './reducers/OffreReducer';
import ReservationReducer from './reducers/ReservationReducer';
import CreneauReducer from './reducers/CreneauReducer';
import UrlSocieteReducer from './reducers/UrlSocieteReducer';
import UrlClientReducer from './reducers/UrlClientReducer';
import { combineReducers } from "redux";
const rootReducers = combineReducers({ restaurant: RestaurantReducer, societe: SocieteReducer, client: ClientReducer, dataRestaurant: DataRestaurantReducer, offre: OffreReducer, reservation: ReservationReducer, creneau: CreneauReducer, urlSociete: UrlSocieteReducer, urlClient: UrlClientReducer});
export default rootReducers;